import type { Langs } from '@CS/components/TranslationProvider/types';
import { getUserLanguage } from '@/redux/user/selectors';
import type { CampaignUnit } from '@/services/api/types';
import { mockedCampaignUnit } from './mockedData';
import { Tile, ContentGrid } from './Tiles.styles';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

export type Size = 'small' | 'medium' | 'large';

type TilesProps = {
  lang?: Langs;
};

function getTranslation<T = string>(
  translations: { [field: string]: { [lang: string]: T } },
  field: string,
  lang: string,
  fallback?: T
): T | undefined {
  const currentLang = lang || 'en';
  return translations?.[field]?.[currentLang] || fallback;
}

const getTileBackground = (bgColor?: string, bgImage?: string) => {
  if (bgColor && bgImage)
    return { background: `${bgColor} url(${bgImage}) center/cover no-repeat` };
  if (bgColor) return { background: bgColor };
  if (bgImage) return { background: `url(${bgImage}) center/cover no-repeat` };
  return {};
};

export const Tiles = ({ lang }: TilesProps) => {
  const [tiles, setTiles] = useState<CampaignUnit[]>();

  const currentLang = lang || 'en';

  useEffect(() => {
    setTiles(mockedCampaignUnit as never as CampaignUnit[]);
  }, []);

  const handleClick = (href: string) => {
    history.pushState(null, '', href);
    window.location.reload(); // Перезагружаем страницу, чтобы WebView перешел по новому URL
  };

  return (
    <ContentGrid>
      {tiles &&
        tiles.map((tile, index) => (
          <Tile
            $lang={lang || 'en'}
            key={index}
            href={tile.ctaUrl}
            $size={tile.itemType as Size}
            data-size={tile.itemType}
            style={{
              ...getTileBackground(
                tile.bgColor,
                tile.bgImageUrls && tile.bgImageUrls[0]
              ),
              ...((currentLang as string) === 'ar' && { direction: 'rtl' })
            }}
            onClick={() => handleClick(tile.ctaUrl)}
          >
            {tile.itemType === 'large' ? (
              <>
                <figure>
                  <img
                    src={tile.imageUrls[0]}
                    alt={tile.title}
                    width="177"
                    height="116"
                    loading="lazy"
                  />
                </figure>
                <article>
                  <h3>
                    {getTranslation(
                      tile.translations || {},
                      'title',
                      lang || 'en',
                      tile.title
                    )}
                  </h3>
                  <p>
                    {getTranslation(
                      tile.translations || {},
                      'description',
                      lang || 'en',
                      tile.description
                    )}
                  </p>
                </article>
              </>
            ) : (
              <>
                <figure>
                  <img
                    src={tile.imageUrls[0]}
                    alt={tile.title}
                    width="70"
                    height="70"
                    loading="lazy"
                  />
                </figure>
                <h3>
                  {getTranslation(
                    tile.translations || {},
                    'title',
                    lang || 'en',
                    tile.title
                  )}
                </h3>
                <p>
                  {getTranslation(
                    tile.translations || {},
                    'description',
                    lang || 'en',
                    tile.description
                  )}
                </p>
              </>
            )}
          </Tile>
        ))}
    </ContentGrid>
  );
};

const mapStateToProps = (state: never) => ({
  lang: getUserLanguage(state)
});

export default connect(mapStateToProps)(Tiles);
